"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "upload-example"
  }, [_c("div", {
    staticClass: "upload-example__cropper-wrapper",
    class: {
      "drop-active": _vm.isDragging
    },
    on: {
      dragover: function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      dragleave: function ($event) {
        $event.preventDefault();
        _vm.isDragging = false;
      },
      drop: function ($event) {
        $event.preventDefault();
        return _vm.onDrop($event);
      }
    }
  }, [!_vm.images.length ? _c("div", {
    staticClass: "upload-example__drop-overlay"
  }, [_c("i", {
    staticClass: "el-icon-upload"
  }), _c("span", [_vm._v("Drop 1 to " + _vm._s(_vm.maxImages) + ' images here or click "Load images"')])]) : _vm._e(), _vm.activeImage ? _c("cropper", {
    key: _vm.activeImage.src,
    ref: "cropper",
    staticClass: "upload-example__cropper",
    attrs: {
      "check-orientation": "",
      src: _vm.activeImage.src,
      "stencil-props": {
        handlers: {},
        movable: true,
        resizable: true,
        scalable: true
      },
      "default-size": _vm.defaultSize
    }
  }) : _vm._e(), _vm.activeImage ? _c("div", {
    staticClass: "upload-example__file-type"
  }, [_vm._v(" Image " + _vm._s(_vm.activeIndex + 1) + " - " + _vm._s(_vm.activeImage.type) + " ")]) : _vm._e()], 1), _vm.images.length ? _c("div", {
    staticClass: "merge-thumbs"
  }, _vm._l(_vm.images, function (img, index) {
    return _c("div", {
      key: img.src,
      staticClass: "merge-thumbs__item",
      class: {
        active: index === _vm.activeIndex
      }
    }, [_c("img", {
      attrs: {
        src: img.croppedUrl || img.src
      },
      on: {
        click: function ($event) {
          _vm.activeIndex = index;
        }
      }
    }), _c("div", {
      staticClass: "merge-thumbs__label"
    }, [_vm._v(" " + _vm._s(index + 1) + _vm._s(img.croppedUrl ? " (cropped)" : "") + " ")]), _c("div", {
      staticClass: "merge-thumbs__actions"
    }, [_c("el-button", {
      attrs: {
        size: "mini",
        icon: "el-icon-arrow-left",
        disabled: index === 0
      },
      on: {
        click: function ($event) {
          return _vm.moveImage(index, -1);
        }
      }
    }), _c("el-button", {
      attrs: {
        size: "mini",
        type: "danger",
        icon: "el-icon-delete"
      },
      on: {
        click: function ($event) {
          return _vm.removeImage(index);
        }
      }
    }), _c("el-button", {
      attrs: {
        size: "mini",
        icon: "el-icon-arrow-right",
        disabled: index === _vm.images.length - 1
      },
      on: {
        click: function ($event) {
          return _vm.moveImage(index, 1);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "upload-example__buttons-wrapper"
  }, [_c("el-button", {
    staticClass: "upload-example__button",
    attrs: {
      disabled: _vm.images.length >= _vm.maxImages
    },
    on: {
      click: function ($event) {
        return _vm.$refs.file.click();
      }
    }
  }, [_c("input", {
    ref: "file",
    attrs: {
      type: "file",
      multiple: "",
      accept: ".jpeg, .jpg, .png"
    },
    on: {
      change: function ($event) {
        return _vm.loadImageFromDisc($event);
      }
    }
  }), _vm._v(" Load images ")]), _vm.activeImage ? _c("el-button", {
    staticClass: "upload-example__button",
    on: {
      click: function ($event) {
        return _vm.applyCrop();
      }
    }
  }, [_vm._v(" Apply crop to image " + _vm._s(_vm.activeIndex + 1) + " ")]) : _vm._e()], 1), _vm.mergedPreview ? _c("div", {
    staticClass: "merge-preview"
  }, [_c("div", {
    staticClass: "merge-preview__title"
  }, [_vm._v(" Merged preview (" + _vm._s(_vm.mergeSize) + " x " + _vm._s(_vm.mergeSize) + ") ")]), _c("img", {
    attrs: {
      src: _vm.mergedPreview
    }
  }), _c("div", {
    staticClass: "upload-example__buttons-wrapper"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "upload-example__button",
    on: {
      click: function ($event) {
        return _vm.uploadMerged();
      }
    }
  }, [_vm._v(" Upload merged image ")]), _c("el-button", {
    staticClass: "upload-example__button",
    on: {
      click: function ($event) {
        return _vm.reset();
      }
    }
  }, [_vm._v(" Clear ")])], 1)]) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;